import { Link, useParams } from "react-router-dom";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/motion";
import { usePageMeta } from "@/lib/api";
import NotFoundPage from "./NotFoundPage";

const DOCS = {
  privacy: {
    title: "Privacy Policy",
    updated: "Placeholder — to be finalised with legal counsel",
    sections: [
      ["What we collect", "When you submit a consultation request or assessment results, we collect the information you provide: name, contact details, organisation information, your message, any files you attach, and the scores you generate in the ESG tools."],
      ["How we use it", "We use this information solely to respond to your enquiry, prepare for consultations, and send you results you have requested. We do not sell your data, and we do not use it for unrelated marketing without consent."],
      ["Storage and security", "Data is stored securely in our application database. Uploaded files are stored in managed object storage with unguessable identifiers and are served only through our own systems."],
      ["Your rights", "You may request access to, correction of, or deletion of your personal data by writing to us. We will respond within a reasonable period."],
      ["Company details", "SarvaRitam — Lower Parel, Mumbai, Maharashtra 400013, India. Phone: +91 92284 11223. Email: sarvaritam@gmail.com. PAN: AFRFS3675M · GSTIN: 27AFRFS3675M1ZZ · UDYAM Registration: UDYAM-MH-19-0371501 · FSSAI Licence: 11525997000839."],
      ["Contact", "For any privacy question, email sarvaritam@gmail.com or use the contact form."],
    ],
  },
  terms: {
    title: "Terms of Use",
    updated: "Placeholder — to be finalised with legal counsel",
    sections: [
      ["Use of this website", "This website provides general information about SarvaRitam's advisory services and interactive tools for self-assessment. By using it, you accept these terms."],
      ["No professional advice", "Content on this website — including tool outputs, articles and the AI assistant — is general information, not professional, legal, regulatory, tax or investment advice. You should obtain specific advice before acting."],
      ["Intellectual property", "The SarvaRitam name, logo, content and tools remain the property of SarvaRitam. Framework names and standards referenced remain the property of their respective organisations."],
      ["Limitation of liability", "Use of this website and its tools is at your own risk. SarvaRitam disclaims liability for decisions made in reliance on general website content."],
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    updated: "Applies to all content, tools and the AI assistant on this website",
    sections: [
      ["Advisory scope", "SarvaRitam provides advisory services. SarvaRitam does not provide legal, regulatory, assurance, tax or investment advice, and does not issue certifications or assurance opinions."],
      ["Framework information", "Framework applicability depends on organisation type, jurisdiction, reporting period and regulatory requirements. Descriptions of frameworks such as BRSR, GRI, ISSB, TCFD, TNFD, SFDR and others are simplified and hedged accordingly; always consult the primary source."],
      ["Interactive tools", "The Carbon Footprint Estimator, BRSR Readiness Checker, ESG Readiness Assessment and ESG Control Room produce illustrative outputs based on simplified logic and default factors. They are not GHG inventories, assurance-ready data or compliance determinations."],
      ["AI assistant", "The Ask SarvaRitam assistant generates AI-based general information, which may be incomplete or out of date. It is not advice and should not be relied upon for decisions."],
    ],
  },
  cookies: {
    title: "Cookie Policy",
    updated: "Placeholder — analytics integration pending",
    sections: [
      ["What we use today", "This website uses minimal local storage only where needed for functionality (for example, remembering your AI assistant session). No advertising or cross-site tracking cookies are used."],
      ["Analytics", "An analytics integration placeholder is in place. When analytics is activated, this policy will be updated with what is collected and how to opt out."],
      ["Managing storage", "You can clear website data from your browser settings at any time; the website will continue to function."],
    ],
  },
};

export default function LegalPage() {
  const { slug } = useParams();
  const doc = DOCS[slug];
  usePageMeta(doc ? `${doc.title} | SarvaRitam` : "Not found | SarvaRitam");
  if (!doc) return <NotFoundPage />;
  return (
    <>
      <PageHero eyebrow="Legal" title={[doc.title]} intro={doc.updated} />
      <section className="bg-offwhite text-charcoal sec">
        <div className="wrap max-w-3xl space-y-12">
          {doc.sections.map(([h, b], i) => (
            <Reveal key={h} delay={i * 0.04}>
              <div>
                <h2 className="h-display font-semibold text-xl sm:text-2xl mb-4">{h}</h2>
                <p className="text-[15.5px] text-charcoal/70 leading-[1.85]">{b}</p>
              </div>
            </Reveal>
          ))}
          <Reveal>
            <p className="text-[13px] text-charcoal/50 border-t rule-light pt-8">
              Questions about this document? <Link to="/contact" className="font-bold text-forest underline">Contact us</Link>.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
